// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__irdHu","pageButtons":"Pagination_pageButtons__wc3W+","pageButton":"Pagination_pageButton__mgSyJ"};